<template>
  <v-dialog
      width="800"
      v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <h2 class="primary--text font-weight-bold pt-5 pl-2">{{$t('display/elevator:overview.playlist-view.view-playlist')}}</h2>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row justify="space-around">
            <v-col cols="4">
              <b>{{ $t('display/elevator:edit.labels.playlist-tab.left-button') }} :</b>
            </v-col>
            <v-col cols="4">
              {{ leftButton.text }}
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="4">
              <b>{{ $t('display/elevator:overview.playlist-view.left-button-media') }} :</b>
            </v-col>
            <v-col cols="4">
              <v-img
                  :src="leftMedia"
                  :max-height="100"
                  :max-width="100"
              />
              {{ leftButton.name }}
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="4">
              <b>{{ $t('display/elevator:edit.labels.playlist-tab.right-button') }} :</b>
            </v-col>
            <v-col cols="4">
              {{ rightButton.text }}
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="4">
              <b>{{ $t('display/elevator:overview.playlist-view.right-button-media') }} :</b>
            </v-col>
            <v-col cols="4">
              <v-img
                  :src="rightMedia"
                  :max-height="100"
                  :max-width="100"
              />
              {{ rightButton.name }}
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="4">
              <b>{{ $t('display/elevator:overview.playlist-view.scheduled-media') }} :</b>
            </v-col>
            <v-col cols="4">
              <v-container>
                <v-row v-for="media in scheduledMedias" :key="media.id">
                  <v-col>
                    <v-img
                        :src="media.src"
                        :max-height="100"
                        :max-width="100"
                        style="float: left"
                    />
                  </v-col>
                  <v-col>
                    {{ media.name }}
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="4">
              <b>{{ $t('display/elevator:overview.playlist-view.carousel-media') }} :</b>
            </v-col>
            <v-col cols="4">
              <v-container>
                <v-row v-for="media in carouselMedias" :key="media.id">
                  <v-col>
                    <v-img
                        :src="media.src"
                        :max-height="100"
                        :max-width="100"
                        style="float: left"
                    />
                  </v-col>
                  <v-col>
                    {{ media.name }}
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="dialog = false"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ElevatorService from '@/modules/display/services/elevator-service';

export default {
  name: "PlaylistView",
  data() {
    return {
      dialog: false,
      leftButton: {},
      rightButton: {},
      leftMedia: null,
      rightMedia: null,
      scheduledMedias: [],
      carouselMedias: []
    }
  },
  methods: {
    initialization(elevatorId) {
      this.setDefault();
      ElevatorService.loadPlaylistInfo(
          elevatorId,
          (response) => {
            if (typeof response.data.id != 'undefined') {
              this.leftButton = {
                text: response.data.button_content_left.button_text,
                name: response.data.button_content_left.media_name
              };
              this.rightButton = {
                text: response.data.button_content_right.button_text,
                name: response.data.button_content_right.media_name,
              };
              this.loadMedia(response.data.button_content_left.media, "left")
              this.loadMedia(response.data.button_content_right.media, "right")
              this.loadedScheduledMedia(response.data.items);
              this.loadedCarouselMedia(response.data.carousel);
            }
            this.dialog = true;
          }
      )
    },
    loadMedia(media, mediaSide) {
      if (!media || !media.id) {
        return;
      }

      ElevatorService.loadMedia(
          media.id,
          result => {
            if (mediaSide === 'left') {
              this.leftMedia = result;
            } else {
              this.rightMedia = result;
            }
          }
      );
    },
    setDefault() {
      this.leftMedia = null;
      this.rightMedia = null;
      this.leftButton = {};
      this.rightButton = {};
      this.scheduledMedias = [];
      this.carouselMedias = [];
    },
    loadedScheduledMedia(items) {
      if (!items || items.length === 0) {
        return;
      }

      for (let i = 0; i < items.length; i++) {
        if (!items[i].media || !items[i].media.id) continue;

        ElevatorService.loadMedia(
            items[i].media.id,
            result => {
              this.scheduledMedias.push({
                src: result,
                name: items[i].media_name,
                id: items[i].id
              })
            }
        );
      }
    },
    loadedCarouselMedia(items) {
      if (!items || items.length === 0) {
        return;
      }

      for (let i = 0; i < items.length; i++) {
        if (!items[i].media || !items[i].media.id) continue;

        ElevatorService.loadMedia(
            items[i].media.id,
            result => {
              this.carouselMedias.push({
                src: result,
                name: items[i].media_name,
                id: items[i].id
              })
            }
        );
      }
    }
  }
}
</script>
